import React, { useState, useEffect, createContext } from 'react'

// Notifications
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

// Grommet
import { Grommet, ResponsiveContext } from 'grommet'

// Appt router
import PrivateRoute from './PrivateRoute'

// Appt Components
import Box from './components/simple/box/Box'

// Appt Screens
import Dashboard from './screens/Dashboard'
import LoginScreen from './screens/Login'
import Logout from './screens/Logout'
import OrganisationEdit from './screens/organisations/OrganisationEdit'
import OrganisationList from './screens/organisations/OrganisationList'
// import PasswordReset from './components/compound/login/PasswordReset'
// import Privacy from './screens/Privacy'
import TandC from './screens/TandC'
import UserEdit from './screens/User/UserEdit'
import UserList from './screens/User/UserList'
import UserUpload from './screens/User/UserUpload'
import ServiceSetup from './screens/ServiceSetup'
import TermsService from './services/TermsService'

import PromptList from './screens/prompts/PromptList'
import PromptEdit from './screens/prompts/PromptEdit'

// Appt Menu
import Sidebar from './components/compound/sidebar/Sidebar'

// Stores
import { useStore, withStore } from 'react-context-hook'

// Services
import LocalStorageService from './services/LocalStorageService'
import NotificationService from './services/NotificationService'
import OrganisationService from './services/OrganisationService'
import PasswordService from './services/PasswordService'

// Utilities

// Theme
import { beSmartTheme } from './utils/beSmartTheme'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faHome as falHome,
  faSave as falSave,
  faUser as falUser,
  faRobot as falRobot,
  faClipboard as falClipboard,
  faUserCircle as falUserCircle,
  faInfoCircle as falInfoCircle,
  faExclamationCircle as falExclamationCircle,
  faClipboardListCheck as falClipboardListCheck,
  faFolderOpen as falFolderOpen,
  faSearch as falSearch,
  faChartPie as falChartPie,
  faPlusCircle as falPlusCircle,
  faMinusCircle as falMinusCircle,
  faQuestionCircle as falQuestionCircle,
  faCloudUpload as falCloudUpload,
  faKey as falKey,
  faTrash as falTrash,
  faEdit as falEdit,
  faEye as falEye,
  faFileAlt as falFileAlt,
  faDownload as falDownload,
  faEnvelope as falEnvelope,
  faCog as falCog,
  faSquare as falSquare,
  faCircle as falCircle,
} from '@fortawesome/pro-light-svg-icons'
import { faCircle, faRobot, faSquare, faInfoCircle, faExclamationCircle, faExclamationTriangle, faGraduationCap, faHome, faSave, faUser, faUserFriends, faPlusSquare, faQuestion, faQuestionCircle, faVideo, faFolderOpen, faMusic, faNewspaper, faFilePdf, faFile, faUpload, faPlus, faThLarge, faGavel, faLink, faAngleRight, faBriefcase } from '@fortawesome/pro-solid-svg-icons'

// Router
import {
  BrowserRouter as Router,
  Routes,
  Route
  // Link
} from 'react-router-dom'

export const GlobalContext = createContext()

function App () {
  library.add(falRobot, falCircle, falInfoCircle, falSquare, falHome, falSave, falUser, falClipboard, falClipboardListCheck, falFolderOpen, falUserCircle, falExclamationCircle, falSearch, falChartPie, falPlusCircle, falMinusCircle, falQuestionCircle, falCloudUpload, falKey, falTrash, falEdit, falEye, falFileAlt, falDownload, falEnvelope, faLink, falCog)
  library.add(faRobot, faCircle, faSquare, faInfoCircle, faExclamationCircle, faExclamationTriangle, faGraduationCap, faHome, faSave, faUser, faUserFriends, faPlusSquare, faQuestion, faQuestionCircle, faVideo, faFolderOpen, faMusic, faNewspaper, faFilePdf, faFile, faUpload, faPlus, faThLarge, faGavel, faAngleRight, faBriefcase)

  const [apiToken, setApiToken, deleteApiToken] = useStore()
  const [currentUser, setCurrentUser, deleteCurrentUser] = useStore({})
  const [currentOrgs, setCurrentOrgs, deleteCurrentOrgs] = useStore([])
  const [activeOrg, setActiveOrg, deleteActiveOrg] = useStore({})
  const [terms, setTerms, deleteTerms] = useStore({})

  const [activeOrgState, setActiveOrgState] = useState([])
  const [myOrganisations, setMyOrganisations] = useState([])
  const [myPermissions, setMyPermissions] = useState([])
  const [loginState, setLoginState] = useState({
    loggedInStatus: false,
    apiToken: '',
    userOrganisations: [],
    userDetails: {}
  })


  const checkLoginStatus = () => {
    // If no apiToken in global store get from local storage
    if (!apiToken) {
      const localApiToken = LocalStorageService.get('apiToken')

      if (localApiToken) {
        setApiToken(localApiToken)
        setCurrentOrgs(LocalStorageService.get('userOrganisations'))
        setCurrentUser(LocalStorageService.get('userDetails'))
        setActiveOrg(LocalStorageService.get('activeOrg'))
        setActiveOrgState(LocalStorageService.get('activeOrg'))
        setMyPermissions(LocalStorageService.get('myPermissions'))

      } else {
        clearSession()
      }
    }

    // always set the terms
    setTerms(LocalStorageService.get('terms'))

    // If no apiToken in local storage either,
    // clear out the session just in case and
    // force a login
    // if (!apiToken) {
    //   // setApiToken(apiToken)
    //   // get currentOrgs
    //   // const myOrganisations = LocalStorageService.get('currentOrgs')
    //   // setCurrentOrgs(myOrganisations)
    // // } else {
    //   clearSession()
    // }
  }

  // clear the user's session if they log out
  const clearSession = () => {
    // remove all localstorage
    LocalStorageService.clear()

    // remove the session data
    deleteApiToken()
    deleteCurrentUser()
    deleteCurrentOrgs()
    deleteActiveOrg()
    deleteTerms()
    // navigate('/')
  }
  // Get system tags to handle common terms
  const getCommonTerms = async () => {

    const matchedTerms = await TermsService.getCommonTerms()

    LocalStorageService.set('terms', matchedTerms)
    setTerms(matchedTerms)
  }

  const handleLogin = (data) => {
    // Set state
    data.loggedInStatus = true
    setLoginState(data)

    // And set in local storage & global store
    LocalStorageService.set('apiToken', data.apiToken)
    setApiToken(data.apiToken)
    LocalStorageService.set('userOrganisations', data.userOrganisations)
    setCurrentOrgs(data.userOrganisations)
    LocalStorageService.set('activeOrg', data.userOrganisations[0])
    setActiveOrg(data.userOrganisations[0])
    setActiveOrgState(data.userOrganisations[0])
    LocalStorageService.set('userDetails', data.userDetails)
    setCurrentUser(data.userDetails)

    getCommonTerms(data.apiToken)

    // store the permissions for easy access
    var myPermissions = []
    if (data?.userOrganisations?.[0]?.permissions?.length > 0) {
      myPermissions = data?.userOrganisations?.[0]?.permissions
    }
    LocalStorageService.set('myPermissions', myPermissions)
    setMyPermissions(myPermissions)
  }

  const handleLogout = () => {
    setLoginState({
      loggedInStatus: false,
      apiToken: '',
      userOrganisations: [],
      userDetails: {}
    })
    clearSession()
  }

  const handlePasswordReset = async (token, data) => {
    try {
      var passwordResetStatus = await PasswordService.resetPassword(token, data.password)
    } catch (err) {
      NotificationService.error(err)
    }

    NotificationService.info('Your password has been reset')

    // history doesn't work in App.js, we'll use this as a test case
    window.location.href = '/login'
  }

  // Set local storage etc with the active organisation
  const selectActiveOrg = (org) => {
    LocalStorageService.set('activeOrg', currentOrgs.find(x => x.id === org))
    setActiveOrg(currentOrgs.find(x => x.id === org))
    setActiveOrgState(currentOrgs.find(x => x.id === org))
    // Why does this not work ?
    // navigate('/')
  }

  // const apiToken = LocalStorageService.get('apiToken')

  // Get Organisation for this User
  const getMyOrganisations = async (apiToken) => {
    if (apiToken) {
      const myOrganisations = await OrganisationService.myOrganisations(apiToken)

      setMyOrganisations(myOrganisations)
    }
  }

  // Basically componentDidMount
  // useEffect(() => {
  //   getMyOrganisations(apiToken)
  // }, [apiToken])
  useEffect(() => {
    checkLoginStatus()
  }, [])


  useEffect(() => {
    var menuSetup = []
    menuSetup.push({ linkHref: '/dashboard', icon: 'home', linkTitle: 'Dashboard ' })
    menuSetup.push({ linkHref: '/services', icon: 'clipboard-list-check', linkTitle: 'Services' })
    menuSetup.push({ linkHref: '/prompt', icon: 'robot', linkTitle: 'Prompts' })
    // menuSetup.push({ linkHref: '/users', icon: 'user-circle', linkTitle: 'System Users' })
    setMenuState(menuSetup)
  }, [activeOrg, myPermissions])

  const serviceSetupTitle = `${terms && terms.service ? terms.service.charAt(0).toUpperCase() + terms.service.slice(1) : 'Service'} Setup`

  const [menuState, setMenuState] = useState([])

  const generateMenu = () => {
    var menuItems = []
    menuItems.push({ linkHref: '/dashboard', icon: 'home', linkTitle: 'Dashboard ' })
    menuItems.push({ linkHref: '/services', icon: 'clipboard-list-check', linkTitle: 'Services' })
    menuItems.push({ linkHref: '/prompt', icon: 'robot', linkTitle: 'Prompts' })
    menuItems.push({ linkHref: '/users', icon: 'user-circle', linkTitle: 'System Users' })

    return menuItems
  }

  return (
    <GlobalContext.Provider value={{ menuState, setMenuState }}>
      <Router>
        <Grommet background={{ color: 'background', image: 'url(/Behaviour-Smart-Background-2.png)' }} full theme={beSmartTheme}>
          <ToastContainer position={'top-right'} />

          <ResponsiveContext.Consumer>
            {size => {
              return (
                <Box className='pageWrapper' align='center' width='100%' height={size !== 'small' ? '100%' : null}>
                  <Box className='pageInnerWrapper' align='center' alignSelf='center' direction='row-responsive' gap='medium' justify='center' margin={{ top: size }} pad={{ horizontal: size }} width='xxlarge'>
                    <Sidebar
                      background='#fff'
                      round='small'
                      width={
                        size === 'small' ? '100%' : 'medium'
                      }
                      data={generateMenu()}
                      dividerColor='brand'
                      history={history}
                      image={myOrganisations && myOrganisations.data ? myOrganisations.data[0].logoUrl : '/BeSmart-Logo-Blue.png'}
                      select={currentOrgs}
                      selected={activeOrgState ? activeOrgState.id : -1}
                      selectActive={selectActiveOrg}
                    />
                    <Box alignSelf='start'>
                      <Routes>
                        <Route
                          terms={terms}
                          path="/services"
                          element={<PrivateRoute><OrganisationList /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          path="/prompt"
                          element={<PrivateRoute><PromptList /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          exact
                          path='/prompt/:id/edit'
                          element={<PrivateRoute><PromptEdit /></PrivateRoute>}
                          activeOrg={activeOrgState}

                        />
                        <Route
                          terms={terms}
                          path="/service/:organisationid/edit"
                          element={<PrivateRoute><OrganisationEdit /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          path="/services"
                          element={<PrivateRoute><OrganisationList /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />

                        <Route
                          terms={terms}
                          path="/user/:userid/edit"
                          element={<PrivateRoute><UserEdit /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          path="/user/new/upload"
                          element={<PrivateRoute><UserUpload type="user" /></PrivateRoute>}
                          activeOrg={activeOrgState}
                          type="user"
                        />
                        <Route
                          terms={terms}
                          path="/users"
                          element={<PrivateRoute><UserList /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          path="/servicesetup/:orgid"
                          element={<PrivateRoute><ServiceSetup /></PrivateRoute>}
                          activeOrg={activeOrgState}
                        />
                        {/* <Route path="/privacy" element={Privacy} /> */}
                            <Route path="/tandc" element={TandC} />
                            <Route
                              path="/logout"
                              element={
                                <Logout
                                  handleLogout={handleLogout}
                                  loggedInStatus={loginState}
                                />
                              }
                            />
                            <Route
                              path="/login"
                              element={
                                <LoginScreen
                                  handleLogin={handleLogin}
                                  handleLogout={handleLogout}
                                  loggedInStatus={loginState}
                                />
                              }
                            />
                        {/* <Route
                          exact
                          path='/reset-password'
                          render={props => (
                            <PasswordReset
                              {...props}
                              handlePasswordReset={handlePasswordReset}
                            />)}
                        /> */}

                      <Route
                          terms={terms}
                          path="/dashboard"
                          element={<PrivateRoute><Dashboard /></PrivateRoute>}
                          loggedInStatus={loginState}
                          activeOrg={activeOrgState}
                        />
                        <Route
                          terms={terms}
                          path="/"
                          element={<PrivateRoute><Dashboard /></PrivateRoute>}
                          loggedInStatus={loginState}
                          activeOrg={activeOrgState}
                        />
                        <Route render={() => <h1>404: page not found - to be created</h1>} />
                      </Routes>
                    </Box>
                  </Box>
                </Box>
              )
            }}
          </ResponsiveContext.Consumer>
        </Grommet>
      </Router>
    </GlobalContext.Provider>
  )
}

export default withStore(App)
